<template>
  <div class="live-dashboard">
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Satış Adet"
          sub-title-text="YTD"
          :value-data="dashboardData.counters.ytdSales | toNumber"
          color-class="success"
          prefix-text=""
          suffix-text="Adet"
          icon-name="ActivityIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Satış Adet"
          sub-title-text="MTD"
          :value-data="dashboardData.counters.mtdSales | toNumber"
          color-class="info"
          prefix-text=""
          suffix-text="Adet"
          icon-name="CalendarIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Toplam Kar Oranı"
          sub-title-text="MTD"
          :value-data="dashboardData.counters.totalProfitRate | toNumber"
          color-class="warning"
          prefix-text="%"
          suffix-text=""
          icon-name="DollarSignIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Takas Adet Oranı"
          sub-title-text="MTD"
          :value-data="dashboardData.counters.swapsRate | toNumber"
          color-class="secondary"
          prefix-text="%"
          icon-name="PercentIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
    </b-row>
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="6"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Aylık Satış Trendi"
            card-sub-title="YTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="monthlySales"
          />
          <div
            v-if="loadings.monthlySales"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <area-charts
              v-if="dashboardData.monthlySales.series.length"
              :series-data="dashboardData.monthlySales.series"
              :categories-data="dashboardData.monthlySales.categories"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Alım Kanalı"
            card-sub-title="YTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="ytdBuyTypes"
          />
          <div
            v-if="loadings.ytdBuyTypes"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <pie-charts
              v-if="dashboardData.ytdBuyTypes.series.length"
              :series-data="dashboardData.ytdBuyTypes.series"
              :labels-data="dashboardData.ytdBuyTypes.labels"
              :colors-data="dashboardData.ytdBuyTypes.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Stok Devir Hızı"
            card-sub-title="YTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="monthlyStockTurnoverRate"
          />
          <div
            v-if="loadings.monthlyStockTurnoverRate"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <column-charts
              v-if="dashboardData.monthlyStockTurnoverRate.series.length"
              :series-data="dashboardData.monthlyStockTurnoverRate.series"
              :categories-data="dashboardData.monthlyStockTurnoverRate.categories"
              :colors-data="dashboardData.monthlyStockTurnoverRate.colors"
            />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Stok Adetleri"
            card-sub-title="Alım Kanalına Göre"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="stocks"
          />
          <div
            v-if="loadings.stocks"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <stacked-bar-charts
              :series-data="dashboardData.stocks.series"
              :categories-data="dashboardData.stocks.categories"
              :colors-data="dashboardData.stocks.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Marka Bazlı"
            card-sub-title="Satış Adetleri"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="salesBrands"
          />
          <div
            v-if="loadings.salesBrands"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <column-charts
              v-if="dashboardData.salesBrands.series.length"
              :series-data="dashboardData.salesBrands.series"
              :categories-data="dashboardData.salesBrands.categories"
              :colors-data="dashboardData.salesBrands.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="5"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Satış Performansı"
            card-sub-title="Alım Kanalı Bazlı"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="salePerformance"
          />
          <div
            v-if="loadings.salePerformance"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <table-performance
              v-if="dashboardData.salePerformance.buyTypes.length"
              :data-list="dashboardData.salePerformance.buyTypes"
              :grand-totals="dashboardData.salePerformance.grandTotals"
            />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <report-customizer
      :cache-info="cacheInfo"
      :refresh-data="refreshDashboard"
      :start-countdown="startCountdown"
    />
  </div>
</template>
<script>
import { BCard, BCol, BRow } from 'bootstrap-vue'
import ReportCustomizer from '@/views/Dashboard/Live/Components/ReportCustomizer.vue'
import CounterCard from '@/views/Dashboard/Live/Components/CounterCard.vue'
import PreLoading from '@/layouts/components/Loading.vue'
import ColumnCharts from '@/views/Dashboard/Live/Charts/ColumnCharts.vue'
import PieCharts from '@/views/Dashboard/Live/Charts/PieCharts.vue'
import AreaCharts from '@/views/Dashboard/Live/Charts/AreaCharts.vue'
import CardCustomHeader from '@/views/Dashboard/Live/Components/CardCustomHeader.vue'
import StackedBarCharts from '@/views/Dashboard/Live/Charts/StackedBarCharts.vue'
import TablePerformance from '@/views/Dashboard/Live/I2SalesDashboard/TablePerformance.vue'

export default {
  name: 'I2SalesDashboard',
  components: {
    TablePerformance,
    StackedBarCharts,
    CardCustomHeader,
    BCard,
    AreaCharts,
    PieCharts,
    ColumnCharts,
    PreLoading,
    CounterCard,
    BRow,
    BCol,
    ReportCustomizer,
  },
  data() {
    return {
      intervalId: null,
    }
  },
  computed: {
    loadings() {
      return this.$store.getters['liveI2SalesDashboard/loadings']
    },
    dashboardData() {
      return this.$store.getters['liveI2SalesDashboard/dashboardData']
    },
    cacheInfo() {
      return this.$store.getters['liveI2SalesDashboard/cacheInfo']
    },
    configData() {
      return this.$store.getters['liveDashboardConfig/configData']
    },
  },
  mounted() {
    this.startCountdown()
  },
  created() {
    this.getDashboard()
  },
  methods: {
    startCountdown() {
      if (this.configData.refreshTime !== false) {
        this.intervalId = setInterval(() => {
          this.refreshDashboard()
        }, this.configData.refreshTime)
      }
    },
    getDashboard() {
      this.getData('counters')
      this.getData('monthlySales')
      this.getData('ytdBuyTypes')
      this.getData('monthlyStockTurnoverRate')
      this.getData('stocks')
      this.getData('salesBrands')
      this.getData('salePerformance')
    },
    refreshDashboard() {
      this.$store.commit('liveI2SalesDashboard/RESET_DASHBOARD_DATA')
      this.refreshData('counters')
      this.refreshData('monthlySales')
      this.refreshData('ytdBuyTypes')
      this.refreshData('monthlyStockTurnoverRate')
      this.refreshData('stocks')
      this.refreshData('salesBrands')
      this.refreshData('salePerformance')
    },
    getData(type) {
      this.$store.dispatch('liveI2SalesDashboard/getData', { type })
    },
    refreshData(type) {
      this.$store.dispatch('liveI2SalesDashboard/refreshData', { type })
    },
  },
}
</script>
<style scoped>
.card-small .card-body{
  padding: 10px !important;
}
.card-fixed{
  overflow: hidden;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
